import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { ILabels } from 'libraries/interfaces/ILabels';

export interface IDescriptionLabels {
    main: string;
    detailIntroduction?: string | string[];
    detailList?: string[];
    syntaxHelp?: string[];
}

@Component({
    selector: 'field-description',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <article>
            <h1>{{ description.main }}</h1>
            <p *ngFor="let detail of this.details"> {{ detail }} </p>
            <ul *ngIf="description.detailList">
                <li *ngFor="let detailList of description.detailList">
                    {{ detailList }}
                </li>
            </ul>
            <p *ngIf="description.syntaxHelp?.length"> {{ labels.syntax }} </p>
            <ul *ngIf="description.syntaxHelp">
                <li *ngFor="let help of description.syntaxHelp">
                    {{ help }}
                </li>
            </ul>
        </article>
    `,
    styles: [`

    :host {
        padding: 10px;
        margin-bottom: 0;
        background-color: #fff;
        color: #7d7d7d;
        box-shadow: 2px 2px 9px -1px rgba(0, 0, 0, .5);
        line-height: normal;
    }

    h1{
        font-size: 16px;
        font-weight: normal;
        margin: 0;
    }

    p{
        font-size: 16px;
        font-weight: normal;
        margin: 10px 0 5px 0;
    }

    ul {
        font-size: 16px;
        font-weight: normal;
        margin: 5px 0;
    }

    li{
        list-style-type: disc;
        list-style-type: '-';
        padding-left: 0.3rem;
    }
    `]
})
export class FieldDescriptionComponent implements OnChanges {
    @Input()
    public description: IDescriptionLabels;

    public details: string[];

    public readonly labels: ILabels = {
        syntax: Yii.t("wui-shared-js", "Supporte les syntaxes :")
    };

    public ngOnChanges(changes: SimpleChanges): void {
        if (!this.description.detailIntroduction) {
            this.details = [];
        } else if (!Array.isArray(this.description.detailIntroduction)) {
            this.details = [this.description.detailIntroduction];
        } else {
            this.details = this.description.detailIntroduction;
        }
    }
}